var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_202_933)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6464 15.6464L23.2929 11L21 8.70711L16.3536 13.3536L16 13.7071L15.6464 13.3536L11 8.70711L8.70711 11L13.3536 15.6464L13.7071 16L13.3536 16.3536L8.70711 21L11 23.2929L15.6464 18.6464L16 18.2929L16.3536 18.6464L21 23.2929L23.2929 21L18.6464 16.3536L18.2929 16L18.6464 15.6464ZM5.03984 26.9602C7.94666 29.867 11.8891 31.5 16 31.5C20.1109 31.5 24.0533 29.867 26.9602 26.9602C29.867 24.0533 31.5 20.1109 31.5 16C31.5 11.8891 29.867 7.94666 26.9602 5.03984C24.0533 2.13303 20.1109 0.5 16 0.5C11.8891 0.5 7.94666 2.13303 5.03984 5.03984C2.13303 7.94666 0.5 11.8891 0.5 16C0.5 20.1109 2.13303 24.0533 5.03984 26.9602ZM6.45406 6.45406C8.9858 3.92232 12.4196 2.5 16 2.5C19.5804 2.5 23.0142 3.92232 25.5459 6.45406C28.0777 8.9858 29.5 12.4196 29.5 16C29.5 19.5804 28.0777 23.0142 25.5459 25.5459C23.0142 28.0777 19.5804 29.5 16 29.5C12.4196 29.5 8.9858 28.0777 6.45406 25.5459C3.92232 23.0142 2.5 19.5804 2.5 16C2.5 12.4196 3.92232 8.9858 6.45406 6.45406Z",
    fill: "#D52B2B",
    stroke: "#D52B2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_202_933"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 32)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossRed);
export default __webpack_public_path__ + "static/media/cross_red.bfc61de6ab13d4a3e197b26e59cce657.svg";
export { ForwardRef as ReactComponent };